import type { KPI } from "@/types/kpiTypes"

export const atTarget = (kpi: KPI, date: string): boolean | undefined => {
  const values = kpi.values?.filter((v) => v.date == date) || []

  if (values.length == 0) return undefined

  const actual = values.find((v) => v.type == "Actual")
  const target = values.find((v) => v.type == "Target")

  if (actual === undefined || target == undefined) return undefined

  return actual.value >= target.value
}
